<template>
  <div class="AfterSalesPolicy">
    <div v-if="imgSales != null">
      <img
        :src="imgSales"
        alt
        width="100%"
        height="100%"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'AfterSalesPolicy',
  props: {
    imgSales: {
      type: String,
    },
  },
  data(){
    return {
      height: 300,
    };
  },
};
</script>

<style>

</style>